// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import constants from "@store/constants";
import { GetTrailerTrackingsV2ApiParameter } from "@store/Framework/Services/TrailerServiceV2";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/Handlers/UpdateDraftParameter";
import { TrailerTrackingV2DataViewResult } from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/TrailerTrackingV2State";
import debounce from "lodash/debounce";
import { useCallback } from "react";

export const useTrailerTrackingV2State = () => {
    return useAppSelector(state => state.greif.pages.trailerTrackingV2);
};

export const useTrailerTrackingV2DataView = (
    parameter?: GetTrailerTrackingsV2ApiParameter,
): TrailerTrackingV2DataViewResult => {
    return useAppSelector(state => {
        const trailerTrackingV2State = state.greif.pages.trailerTrackingV2;

        return getDataView(trailerTrackingV2State, parameter || trailerTrackingV2State.parameter);
    });
};

export const useTrailerTrackingV2DebouncedUpdateDraftParameter = () => {
    const dispatch = useAppDispatch();

    return useCallback(
        debounce(
            (parameter: GetTrailerTrackingsV2ApiParameter) => dispatch(updateDraftParameter(parameter)),
            constants.searchDebounceDelay,
        ),
        [],
    );
};
